'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchX } from 'lucide-react';

import { Flex, Icon, Text } from '@nutralab/ui';

import styles from './SearchEmptyState.module.scss';

export function SearchEmptyState(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Flex direction="column" align="center" justify="center" gap={4} className={styles['empty-state']}>
            <Icon icon={SearchX} size="3xl" strokeWidth={1.5} className={styles.icon} />
            <Text color="muted" size="sm">
                {t('landing.search.empty')}
            </Text>
        </Flex>
    );
}
